var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"container-fluid"},[_c('user-menu-actions',{attrs:{"disableButtons":_vm.isActionActive}}),(this.noFeeds)?_c('user-menu-info-no-feeds'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }